import type { Domain } from 'bundles/front-page/redesign-modules/domains/DomainPill';

import _t from 'i18n!nls/front-page';

const getDomainData = (): Domain[] => {
  return [
    {
      id: 'business',
      slug: 'business',
      name: _t('Business'),
    },
    {
      id: 'artificial-intelligence',
      slug: 'artificial-intelligence',
      name: _t('Artificial Intelligence'),
      href: '/explore/generative-ai',
    },
    {
      id: 'data-science',
      slug: 'data-science',
      name: _t('Data Science'),
    },

    {
      id: 'computer-science',
      slug: 'computer-science',
      name: _t('Computer Science'),
    },
    {
      id: 'information-technology',
      slug: 'information-technology',
      name: _t('Information Technology'),
    },
    {
      id: 'personal-development',
      slug: 'personal-development',
      name: _t('Personal Development'),
    },
    {
      id: 'health',
      slug: 'health',
      name: _t('Healthcare'),
    },
    {
      id: 'language-learning',
      slug: 'language-learning',
      name: _t('Language Learning'),
    },
    {
      id: 'social-sciences',
      slug: 'social-sciences',
      name: _t('Social Sciences'),
    },

    {
      id: 'arts-and-humanities',
      slug: 'arts-and-humanities',
      name: _t('Arts and Humanities'),
    },
    {
      id: 'physical-science-and-engineering',
      slug: 'physical-science-and-engineering',
      name: _t('Physical Science and Engineering'),
    },
    {
      id: 'math-and-logic',
      slug: 'math-and-logic',
      name: _t('Math and Logic'),
    },
  ];
};

export default getDomainData;
